import type { ChartCategory } from '../constants/dashboardChartCategories';

export interface DistributionLegendRow extends ChartCategory {
  value: number;
  percent: number;
}

export interface DistributionBarPoint {
  name: string;
  value: number;
  color: string;
}

export function buildDistributionChartData(
  categories: readonly ChartCategory[],
  rawCounts: Record<string, number> | undefined,
): {
  legend: DistributionLegendRow[];
  quantity: DistributionBarPoint[];
  percent: DistributionBarPoint[];
} {
  const total = categories.reduce(
    (acc, category) => acc + (Number(rawCounts?.[category.key]) || 0),
    0,
  );

  const legend: DistributionLegendRow[] = categories.map((category) => {
    const value = Number(rawCounts?.[category.key]) || 0;
    const percent = total > 0 ? Math.min(100, Math.round((value / total) * 1000) / 10) : 0;
    return { ...category, value, percent };
  });

  const quantity = legend.map(({ label, value, color }) => ({
    name: label,
    value,
    color,
  }));

  const percent = legend
    .filter((row) => row.percent > 0)
    .map(({ label, percent: pct, color }) => ({
      name: label,
      value: pct,
      color,
    }));

  return { legend, quantity, percent };
}
